'use client';

import React from 'react';
import WidgetLoading from 'src/components/Profiles/shared/widgets/shared/WidgetLoading';
import { useProfile } from 'src/context/providers/ProfileProvider';
import { useGetPatientVisitValueQuery } from 'src/api/redux';
import { formatCurrency } from 'src/utils/formatCurrency/formatCurrency';
import { useWidgetConfig } from 'src/context/providers/WidgetConfigProvider';
import { EvidenceInfoIcon } from '../PlaysSection/components';

const SlotValue: React.FC = () => {
  const widgetConfig = useWidgetConfig();
  const widget = widgetConfig?.widget;
  const { entityDetails } = useProfile();
  const entityId = entityDetails?.id;
  const codeSetId = widget?.code_set?.id;

  const { data, isLoading } = useGetPatientVisitValueQuery(
    { entityId: entityId ?? '', codeSetId: codeSetId ?? 0 },
    { skip: !entityId || !codeSetId }
  );

  return (
    <div
      className="flex-1 rounded-2xl bg-white shadow-sm p-5 flex flex-col gap-1"
      data-testid="slot-value"
      role="region"
      aria-label="Slot Value"
    >
      {isLoading ? (
        <WidgetLoading data-testid="slot-value-loading" />
      ) : data?.patient_visit_value == null ? (
        <p
          className="text-sm font-semibold text-neutral-500"
          data-testid="slot-value-empty"
        >
          No data available
        </p>
      ) : (
        <>
          <div className="flex items-start justify-between gap-2">
            <p className="text-sm font-semibold text-neutral-500 leading-5">Slot Value</p>
            {widget?.evidence && (
              <EvidenceInfoIcon
                evidence={widget.evidence}
                data-testid="slot-value-evidence-icon"
              />
            )}
          </div>
          <p
            className="text-2xl font-bold text-neutral-800 tabular-nums"
            data-testid="slot-value-amount"
          >
            {formatCurrency(data.patient_visit_value, { abbreviated: false })}
          </p>
          <p className="text-sm text-neutral-500">
            Average patient slot value
          </p>
        </>
      )}
    </div>
  );
};

export default SlotValue;
